import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import React, { ComponentType } from 'react'

type CustomFieldItem = Pick<CellItem, 'column'>

const withCustomField =
  <T extends CustomFieldItem>(
    Component: ComponentType<T>,
    overriddenProps: CustomFieldItem
  ) =>
  props =>
    <Component {...props} {...overriddenProps} />

export default withCustomField
